/**
 * Get the main copy for the referral nano banner.
 *
 * @param {Object|null} [referralRewards]
 * @param {number} referralRewards.newCustValue - Credits rewarded to the referee
 * @param {number} referralRewards.referrerValue - Credits rewarded to the referrer
 * @returns {string|null} Formatted referral nano banner copy, or null if values are missing
 */
export function getReferralNanoBannerCopy(referralRewards) {
    const { newCustValue, referrerValue } = referralRewards ?? {};
    if (newCustValue == null || referrerValue == null) return null;
    return `Limited time: Give friends $${newCustValue} off their 1st order, get $${referrerValue} in credits.`;
}
